/* oxlint-disable no-restricted-imports */
import { ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        "text-inherit",

        "text-h1",
        "text-h2",
        "text-h3",
        "text-h4",
        "text-body1",
        "text-body2",
        "text-caption",
      ],
    },
  },
})

export const cn = (...inputs: ClassValue[]) => {
  return customTwMerge(clsx(inputs))
}

type Color =
  // Base colors
  | "transparent"
  | "current"
  | "white"
  | "black"
  // Brand Secondary
  | "brand-secondary-100"
  | "brand-secondary-200"
  | "brand-secondary-300"
  | "brand-secondary-400"
  | "brand-secondary-500"
  | "brand-secondary-700"
  | "brand-secondary-900"
  // Accent 1
  | "accent-1-100"
  | "accent-1-200"
  | "accent-1-300"
  | "accent-1-500"
  // Error
  | "error-100"
  | "error-200"
  | "error-300"
  | "error-400"
  | "error-500"
  | "error-600"
  | "error-700"
  | "error-800"
  | "error-900"
  // Success
  | "success-100"
  | "success-200"
  | "success-300"
  | "success-500"
  | "success-600"
  | "success-800"
  | "success-900"
  // Grey
  | "grey-100"
  | "grey-300"
  | "grey-400"
  | "grey-500"
  | "grey-700"
  | "grey-800"
  | "grey-900"
  // Haze
  | "haze-100"
  | "haze-200"
  | "haze-700"
  // Sand
  | "sand-100"
  | "sand-200"
  | "sand-300"
  | "sand-500"

export const getThemeColor = (color: Color) => {
  const varName = `--color-${color}`
  return getCssVar(varName)
}

export const getCssVar = (key: string) => {
  const value = getComputedStyle(document.body).getPropertyValue(key)
  return value
}
